import { render, staticRenderFns } from "./all-printers.vue?vue&type=template&id=021c5c98"
import script from "./all-printers.vue?vue&type=script&lang=js"
export * from "./all-printers.vue?vue&type=script&lang=js"
import style0 from "./all-printers.vue?vue&type=style&index=0&id=021c5c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports